$(document).ready(function () {
    $('.js-deepdyve-link').hide();
    var deepDive = $('.js-deepdyve-link');
    if (deepDive.length > 0) {
        var doi = deepDive.data('doi');
        var issn = deepDive.data('issn');
        var eissn = deepDive.data('eissn');
        var fieldname = deepDive.data('fieldname');
        var affiliate = deepDive.data('affiliate');
        var journal = issn;
        if (issn == '') {
            journal = eissn;
        }
        if (doi != null && fieldname != null && affiliate != null && issn != null) {
            var url = 'https:////www.deepdyve.com/rental-link?docId=' + doi + '&journal=' + journal + '&fieldName=' + fieldname + '&affiliateId=' + affiliate + '&format=jsonp&callback=?';
            //http://www.deepdyve.com/rental-link?docId=10.1016/j.hrmr.2012.06.003&journal=10534822&fieldName=journal_doi&affiliateId=bioportfolio&format=jsonp&callback=?
            $.getJSON(url, function (data) {
                if (data.status === 'ok') {
                    // Update the href url so it goes straight to the article page
                    $('.js-deepdyve-link a').attr('href', data.url);
                    $('.js-deepdyve-link').show();
                }
            });
        }
    }
});
